import { ICurrency } from './index'

export default function fetchCurrency(api: GlobalFetch) {
  return function() {
    return api
      .fetch(`/api/v2/misc/currency/`)
      .then((res): Promise<IData> => res.json())
      .then((res): ICurrency[] =>
        res.items.map(
          (item): ICurrency => ({
            id: item.id,
            name: item.name,
          }),
        ),
      )
  }
}

interface IData {
  items: ICurrencyData[]
  messages: string[]
}

interface ICurrencyData {
  id: string
  name: string
}
